import { render, staticRenderFns } from "./PolicyUpdatePopup.vue?vue&type=template&id=2f3ed10f&scoped=true"
import script from "./PolicyUpdatePopup.vue?vue&type=script&lang=ts"
export * from "./PolicyUpdatePopup.vue?vue&type=script&lang=ts"
import style0 from "./PolicyUpdatePopup.vue?vue&type=style&index=0&id=2f3ed10f&prod&lang=less"
import style1 from "./PolicyUpdatePopup.vue?vue&type=style&index=1&id=2f3ed10f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3ed10f",
  null
  
)

export default component.exports